module.exports = __webpack_public_path__ + "static/cpf-7d9318e834f2ec85732a25156ab0cdda.png";